$(document).ready(function (){
    showSort()
    $("#add-billboard").on('click',function (){
        $("#modal-billboard").modal('show')
        $('#form-billboard').trigger("reset")
        $("#item-route").val('/admin/img-billboard/add')
    })

    $(document).on('click','.update-billboard',function (e){
        let info = $(this).data('info')
        $(".billboard-img").val('')
        $.each(info,function (index,value){
            $("#item-"+index).val(value)
            if (index == "imagen") {
                $("#item-image").attr("src",'../images/banners/'+value);
            }
        })
        $("#item-route").val('/admin/img-billboard/update')
        $("#modal-billboard").modal('show')
    })

    $(document).on('click','.update-status-billboard',function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        var item = $(this).data('id')
        let data = new FormData()
        data.append('item',item)
        sendInfo("/admin/update-status-bilboard",data,'Registro actualizado')
    })

    $(document).on('click','.delete-status-billboard',function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        var item = $(this).data('id')
        let data = new FormData()
        data.append('item',item)
        sendInfo("/admin/delete-bilboard",data,'Registro actualizado')
    })

    $("#form-billboard").on('submit',function (e){
        e.preventDefault()
        let method = $("#item-method").val()
        let data = new FormData(this)
        let route = $("#item-route").val()
        let msg = route == "/admin/img-slider/add" ? "Registro agregado" : "Registro actualizado"
        sendInfo(route,data,msg)
    })

    function sendInfo(route,data,msg) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route,
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    $("#modal-billboard").modal('hide')
                    alertSuccess(msg)
                    document.getElementById('div_partials_billboard').innerHTML = response;
                    showSort()
                }, 1000)
            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }



    function showSort()
    {
        $("#list-billboard-home").sortable({
            update: function (event, ui) {
                update(event, ui); // Llamada a la función update al mover un elemento
            }
        });
    }
})
